/**
 * Confirmation dialog for deleting a show
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
} from '@mui/material';

interface DeleteShowDialogProps {
  open: boolean;
  showTitle: string;
  holdCount: number;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isDeleting?: boolean;
  errorMessage?: string | null;
}

export const DeleteShowDialog: React.FC<DeleteShowDialogProps> = ({
  open,
  showTitle,
  holdCount,
  onClose,
  onConfirm,
  isDeleting = false,
  errorMessage,
}) => {
  return (
    <Dialog open={open} onClose={isDeleting ? undefined : onClose} disableEscapeKeyDown={isDeleting}
      closeAfterTransition={false} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Show?</DialogTitle>
      <DialogContent>
        {errorMessage && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage}</Alert>}
        {holdCount > 0 && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This show has {holdCount} hold{holdCount > 1 ? 's' : ''}. All holds
            will be permanently deleted.
          </Alert>
        )}
        <DialogContentText>
          Are you sure you want to delete "{showTitle}"? This action cannot be
          undone and will permanently remove all associated data including
          holds, dates, and financial information.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting} autoFocus>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
